import React, { useState, useEffect } from "react";
import Footer from "../../../Gerneralcomponents/Footer/footer";
import Swal from "sweetalert2";
import { domain } from "../../../Urls/Services/Api_urls";
import Logonew from "../../../assets/LogoNew.webp";

export default function Rescontra() {
  const [email, setEmail] = useState("");
  const [url, setUrl] = useState("");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const type = params.type;

  const urlpass = {
    Changepass: "/user/reset/password/",
    Changepassgo: "/directv/send_email/",
  };

  useEffect(() => {
    setUrl(domain + urlpass[type]);
  }, [type]);

  const rescontra1 = (e) => {
    e.preventDefault();
    const credentials = { email };
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials),
    })
      .then(async (response) => {
        const responseBody = await response.text();
        let errorMsg = JSON.parse(responseBody);
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Se ha enviado correo electrónico",
            text: errorMsg.msg,
            timer: 5000,
          }).then(() => {
            window.location.href = "/Recuperarcontra";
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMsg.msg,
          });
        }
      })
      .catch((error) => {
        Swal.showValidationMessage(`Request failed: ${error}`);
      });
  };

  return (
    <div>
      <section className="derecha flex justify-center items-center min-h-screen bg-gray-100">
        <div className="shadow-md backdrop-blur-sm rounded-3xl bg-white/70 flex flex-col justify-center items-center p-6">
          <a href="/" className="flex items-start my-8">
            <img className="w-52" src={Logonew} alt="Logo" />
          </a>
          <form onSubmit={rescontra1} className="w-full flex flex-col items-center">
            <label className="text-gray-700 font-semibold mb-2" htmlFor="email">
              Correo electrónico
            </label>
            <input
              id="email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-72 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
              required
            />
            <button
              type="submit"
              className="w-40 mt-4 text-white py-2 rounded-xl bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:ring focus:ring-blue-300"
            >
              <b>Enviar</b>
            </button>
          </form>
          <a
            className="mt-10 text-red-950/70 hover:text-red-600 focus:ring focus:ring-red-300"
            href="/Recuperarcorreo"
          >
            ¿Has olvidado tu correo?
          </a>
          <a
            className="mt-2 text-red-950/70 hover:text-red-600 focus:ring focus:ring-red-300"
            href="/Login"
          >
            Ingresar
          </a>
        </div>
      </section>
      <Footer />
    </div>
  );
}
